import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { BalooEditContainerComponent } from './baloo-edit-container/baloo-edit-container.component';
import { BalooService } from '@fi-app/external-platform-integration/baloo/baloo.service';
import { BalooSettingsComponent } from '@fi-app/external-platform-integration/baloo/baloo-settings/baloo-settings.component';
import { BalooMatchComponent } from '@fi-app/external-platform-integration/baloo/baloo-match/baloo-match.component';
import { BalooSyncLogComponent } from '@fi-app/external-platform-integration/baloo/baloo-sync-log/baloo-sync-log.component';
import { BalooManualSyncComponent } from '@fi-app/external-platform-integration/baloo/baloo-manual-sync/baloo-manual-sync.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

const BalooState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.Baloo._name,
    url: '/Baloo',
    abstract: true,
    views: {
        '@': {
            component: BalooEditContainerComponent,
        },
    },
};

const BalooEditSettingsState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.Baloo.Settings,
    url: '/Settings',
    component: BalooSettingsComponent,
    resolve: {
        balooSettings: [BalooService, balooResolveGetBalooSettings],
        //isAutoImportAvailable: [BalooService, balooResolveIsAutoImportAvailable]
    },
};
export function balooResolveGetBalooSettings(balooService: BalooService) {
    return balooService.getBalooSettings();
}
/*export function balooResolveIsAutoImportAvailable(balooService: BalooService) {
    return balooService.isAutoImportAvailable();
}*/

const BalooUnitsMatchingState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.Baloo.Matching,
    url: '/Matching',
    component: BalooMatchComponent,
    resolve: {
        balooMatchData: [
            BalooService,
            (balooService: BalooService) => {
                return balooService.getMatchData();
            },
        ],
    },
};

const BalooManualSyncState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.Baloo.ManualSync,
    url: '/ManualSync',
    component: BalooManualSyncComponent,
};

const BalooImportLogState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.Baloo.SyncLog,
    url: '/SyncLog?:filterType&:sortColumn&:sortDirection&:offset',
    params: {
        selectedTabIndex: undefined,
        selectedSyncLogId: undefined,
    },
    reloadOnSearch: false,
    component: BalooSyncLogComponent,
    resolve: {
        selectedTabIndex: [
            FiStateService,
            Transition,
            (fiStateService: FiStateService, tr: Transition) => {
                return fiStateService.getParams(tr).selectedTabIndex;
            },
        ],
        selectedSyncLogId: [
            FiStateService,
            Transition,
            (fiStateService: FiStateService, tr: Transition) => {
                return fiStateService.getParams(tr).selectedSyncLogId;
            },
        ],
    },
};

export const BalooStates: StatesModule = {
    states: [BalooState, BalooEditSettingsState, BalooUnitsMatchingState, BalooManualSyncState, BalooImportLogState],
};

export function registerBalooStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.OtherSettings.Baloo._name], {
        SettingType: [ApplicationSettingsType.BalooELearning],
        AccessType: AccessRightType.Admin,
    });
}
